<app-modal #pfasModal [modalConfig]="modalConfig">
  <div class="text-center">
    <div class="text-center">
      <div class="title-desc mb-3" i18n>PFAS Shipping Restriction</div>
      <div class="col-md-12-mx-12 pfas-law-desc">
        <p i18n>We're unable to ship one or more of your selected product(s) to your shipping address due to a PFAS prohibition.</p>
        <p i18n>For more information on PFAS restrictions by state, please see our
          <a aria-label="Minnesota" target="_blank" [href]="url" class="link-highlight">Product Disclosures</a> page.
        </p>
        <p i18n>To continue with your order, please remove the restricted product(s) listed below from your cart. Once removed, you can proceed to checkout.</p>
      </div>
     <div class="heading" i18n>Restricted Product(s):</div>
      <div *ngIf="pfasCartItems" class="text-align: left">
        <div class="ph-row" *ngFor="let cartItem of pfasCartItems">
          <div class="col-xs-2" i18n>{{ cartItem.sku | titlecase }}</div>
          <div class="product-desc col-md-9 " i18n>{{ cartItem.productName }}</div>
        </div>
      </div>
    </div>
  </div>
</app-modal>